import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";

import Sidebar from "./components/Sidebar";
import MobileNav from "./components/MobileNav";
import PersistentPlayer from "./components/PersistentPlayer";
import EnvBanner from "./components/EnvBanner";
import { ProtectedRoute } from "./components/ProtectedRoute";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MusicLibrary from "./pages/MusicLibrary";
import SermonsLibrary from "./pages/SermonsLibrary";
import RadioPage from "./pages/RadioPage";
import SubmitPage from "./pages/SubmitPage";
import MySubmissionsPage from "./pages/MySubmissionsPage";
import AdminDashboard from "./pages/AdminDashboard";
import PlaylistsPage from "./pages/PlaylistsPage";
import FavoritesPage from "./pages/FavoritesPage";
import StationsPage from "./pages/StationsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function Layout() {
  return (
    <div className="min-h-screen bg-[#060709]">
      <EnvBanner />
      <Sidebar />
      <MobileNav />
      <main className="lg:pl-64">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-12 pb-28 lg:pb-12">
          <Outlet />
        </div>
      </main>
      <PersistentPlayer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PlayerProvider>
          <Toaster theme="dark" position="top-right" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/radio" element={<RadioPage />} />
              <Route path="/stations" element={<StationsPage />} />
              <Route path="/music" element={<MusicLibrary />} />
              <Route path="/sermons" element={<SermonsLibrary />} />

              <Route path="/submit" element={<ProtectedRoute><SubmitPage /></ProtectedRoute>} />
              <Route path="/my-submissions" element={<ProtectedRoute><MySubmissionsPage /></ProtectedRoute>} />
              <Route path="/playlists" element={<ProtectedRoute><PlaylistsPage /></ProtectedRoute>} />
              <Route path="/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />

              <Route
                path="*"
                element={
                  <div className="text-center py-32">
                    <h1 className="font-serif text-5xl text-[#FDFBF7] mb-4">404</h1>
                    <p className="text-[#A1A4AB]">Page not found.</p>
                  </div>
                }
              />
            </Route>
          </Routes>
        </PlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
